<script setup lang="ts">
import Sidebar from '@/parts/Sidenavbar.vue'
import Navbar from '@/parts/Navbar.vue'
import { useGlobalStore } from '@/stores/global'
import { context } from '@/services'
import { RouterLink } from 'vue-router'

const globalStore = useGlobalStore()

const topTabs = [
  { name: 'home', label: 'لوحة المعلومات' },
  { name: 'mosque-presence-dashboard', label: 'حضور المسجد' }
] as const
</script>

<template>
  <!-- Sidebar component -->
  <div
    class="flex bg-background min-h-[100dvh]"
    :class="{
      'dark:bg-gray-900': context !== 'bayen_school',
      'dark:bg-[#1a0a11]': context === 'bayen_school'
    }"
  >
    <!-- <Sidebar /> -->

    <main
      class="max-h-screen overflow-y-auto flex-grow transition-all duration-300 ease-in-out"
      :class="{
        'w-0 ': globalStore.isToggled
      }"
    >
      <Navbar />
      <!-- <div class="px-3 md:px-4 lg:px-6">
        <div
          class="mt-2 rounded-xl border border-gray-200 bg-white/80 px-2 py-2 shadow-sm backdrop-blur-sm dark:border-gray-700 dark:bg-gray-800/80"
        >
          <div class="flex flex-wrap items-center justify-center gap-2">
            <RouterLink
              v-for="tab in topTabs"
              :key="tab.name"
              :to="{ name: tab.name }"
              custom
              v-slot="{ navigate, href, isExactActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="rounded-lg px-4 py-2 text-sm font-medium transition-colors"
                :class="
                  isExactActive
                    ? 'bg-primary text-white shadow-sm'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600'
                "
              >
                {{ tab.label }}
              </a>
            </RouterLink>
          </div>
        </div>
      </div> -->
      <div class="lg:p-6 md:p-4 p-3 transition-all duration-300 ease-in-out relative">
        <slot />
      </div>
    </main>
  </div>
</template>

<style>
/* @import 'datatables.net-dt'; */
.datatable {
  margin: 15px;
}
</style>
